import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa'; // Import social media icons
import logo from '../assets/logo/MC_2607_Logo-02.png';

function Footer() {
  const lineRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    };
  
    const lineElement = lineRef.current; 
    const elements = document.querySelectorAll('.animation-footer-text');

    const observer = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          lineElement.classList.add('animated-line');

        } else {
          lineElement.classList.remove('animated-line');
        }
      });
    }, options);
  
    // Start observing the line element
    observer.observe(lineElement);
  
    // Clean up observer when component unmounts
    return () => {

      if (lineElement) {
        observer.unobserve(lineElement);
      }
    };
  }, []);



  return (
    <>
    <footer className="relative md:w-full bg-mcare-green text-white md:py-16 pt-10 pb-16 shadow-footer ">
      <div className='bg-black/60 absolute inset-0 z-0'/>

      <div className='relative z-20'>
          <div className="w-full flex justify-center items-center text-center z-20 pb-10 ">
            {/* <a href="link_to_facebook" target='blank className={`text-4xl px-3 md:m-0 hover:text-gray-400 `} ><FaFacebook /></a> */}
            <a href="https://www.instagram.com/mcare_fisio_sportclinic?igsh=cDN6enAybXV2YjVr" target='blank' className={`text-4xl px-3 md:m-0 hover:text-white/50 `} ><FaInstagram /></a>
            <a href="https://wa.me/+393202474886" target='blank' className={`text-4xl px-3 md:m-0 hover:text-white/50 `} ><FaWhatsapp /></a>
          </div>
          <div className="w-full flex justify-center items-center  text-center z-20 pb-10">
          <p className="text-white text-center text text-xl w-5/6 md:w-2/5"><em className='font-semibold'>Contattaci, siamo a tua completa disposizione per fornirti tutta l'assistenza e la consulenza di cui hai bisogno.</em></p>
          </div>
            <div className="w-full flex justify-center items-center z-20">
                <div className={`text-center w-80 md:w-1/2 mx-auto`}>
                    <img src={logo} className="bg-contain w-1/2 md:w-1/3 xl:w-1/4 mb-8 mx-auto" alt="logo mcare" />
                    {/* <p className={`md:text-2xl text-lg font-semibold uppercase mb-2 panoragraf-light`}>MCARE</p> */}
                    <p className={`text-sm md:text-lg`}>Via Enrico Fermi, 13/A, CAP. 37135, Verona (VR)</p>
                    <p className={`text-sm md:text-lg mb-4`}>Via Toscana, 13, CAP. 37060, Sona (VR)</p>
                    <p className={`text-sm md:text-lg`}>C.f. e P.IVA 05003310231 REA VR-462764</p>
                    <p className={`text-sm md:text-lg`}>Aperto dalle 9.00 alle 20.00<br/>Verona: Tel. 0459856026 - Cell. +39 320 2474886</p>
                    <p className={`text-sm md:text-lg`}>Sona: Cell. +39 353 2137757</p>
                    <p className={`text-sm md:text-lg`}>Reperibilità telefonica dalle 07.00 alle 09.00 e dalle 20.00 alle 23.00</p>
                    <p className={`text-sm md:text-lg`}>Email: info@mcarefisio.it</p>

                    <hr ref={lineRef} className="border-b border-white/50 my-4" />

                    <div className="flex flex-wrap justify-center md:space-x-8">
                        <Link to='/privacypolicy' className={`text-sm me-3 mt-3 md:m-0 hover:text-white/50 `} >Privacy Policy</Link>
                        {/* <Link to='/cookie-policy' className={`text-sm me-3 mt-3 md:m-0 hover:text-gray-400`} >Cookie Policy</Link> */}
                    </div>                
                </div>
            </div>
      </div>
    </footer>
    </>
  );
}

export default Footer;
